import type { WorkspaceContentFragment } from "gql-types/documents/web-client";
import { Icon, MessageStripe, Stack, Text } from "prism-react";
import React from "react";

import { paths } from "utils/router";

const OUT_OF_CREDITS_TRESHOLD = 50; // 50 credits left from the free plan included credits

export const CloseToOutOfCredits: React.FC<{
  workspace: WorkspaceContentFragment;
  isAdmin: boolean;
}> = ({ workspace, isAdmin }) => {
  const { featureFlags, limits, usage } = workspace;
  const remainingCredits = limits.includedCredits - usage.credits;

  const isCloseToOutOfCredits =
    featureFlags.ubbBeta &&
    !featureFlags.friendOfCsb &&
    remainingCredits > 0 &&
    remainingCredits < OUT_OF_CREDITS_TRESHOLD;

  if (!isCloseToOutOfCredits) {
    return null;
  }

  return (
    <MessageStripe corners="straight" variant="warning">
      <Stack gap={2} horizontal>
        <Icon type="circleBang" />
        <Text>
          <Text weight="medium">Your workspace is low on credits.</Text> If you
          run out of credits, your Devboxes will be frozen.{" "}
        </Text>
      </Stack>
      {isAdmin && (
        <MessageStripe.Action
          as="a"
          href={paths.upgrade({
            source: "out_of_credits_banner",
            workspaceId: workspace.id,
          })}
        >
          Upgrade to Pro
        </MessageStripe.Action>
      )}
    </MessageStripe>
  );
};
